// ============================================================================
// File: src/modules/ppe/pages/procurement/dashboard/services/dashboardService.js
// Purpose:
//   Handles Procurement Dashboard API communication
// ============================================================================

import axiosClient from "../../../../../../api/axiosClient";

export const fetchProcurementDashboard = async () => {
  const response = await 
    axiosClient.get("/api/ppe/material-flow/procurement/dashboard");
  

  return response.data;
};
